import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18140 Добавить проверку текущего значения полной квоты для отображения
export const overquotaUseQuotaForProfileApi: boolean | undefined = getFeature('overquota-use-quota-for-profile-api');
